import * as yup from "yup";

const schema = yup.object().shape({
    notes: yup
    .string()
    .test("is-validate", "Public Note note must be between 10 and 2000 characters", (value) => {
        if (value?.length > 0) {
            return value.length > 10 && value.length <= 2000;
        }
        return true;
    }
    ),
    privateNote: yup
    .string()
    .test("is-validate", "Private Note note must be between 10 and 600 characters", (value) => {
        if (value?.length > 0) {
            return value.length > 10 && value.length <= 600;
        }
        return true;
    }
    ),
});

export default schema;
